import { render, staticRenderFns } from "./BangTheoDoiCoc.vue?vue&type=template&id=0808463d&"
import script from "./BangTheoDoiCoc.vue?vue&type=script&lang=js&"
export * from "./BangTheoDoiCoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports